// custom.js
function initializeSlickSlider() {
  $(".product__icon__row").slick({
    arrows: true,
    dots: true,
    infinite: false,
    slidesToShow: 1,
  });
}
// initializeSlickSlider();

var $slick_slider = $(".product__icon__row");
var screen_size = 767;
var settings_slider = {
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

slick_on_mobile($slick_slider, settings_slider);

function slick_on_mobile(slider, settings) {
  $(window).on("load resize", function () {
    if ($(window).width() < screen_size) {
      if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");
      }
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

var windowWidth = $(window).width();

// mobile media slider product

// var $slick_sliderproduct = $('.product__images--no-thumbs .product__slides');
//   var screen_sizeproduct = 767;
//   var settings_sliderproduct = {
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       dots: true,
//       autoplay: false,
//       autoplaySpeed: 5000,
//       infinite: false,
//   }

//   Slick_media( $slick_sliderproduct, settings_sliderproduct);

//   function Slick_media(sliderpro, settings){
//       $(window).on('load resize', function() {
//         if ($(window).width() > screen_sizeproduct) {
//           if (sliderpro.hasClass('slick-initialized')) {
//             sliderpro.slick('unslick');
//           }
//           return
//         }
//         if (!sliderpro.hasClass('slick-initialized')) {
//           return sliderpro.slick(settings);
//         }
//       });
//   };

var $slick_sliderproduct = $(".product__images--no-thumbs .product__slides");
var screen_sizeproduct = 767;
var settings_sliderproduct = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  autoplay: false,
  autoplaySpeed: 5000,
  infinite: false,
};

function Slick_media(sliderpro, settings) {
  $(window).on("load resize", function () {
    if ($(window).width() > screen_sizeproduct) {
      if (sliderpro.hasClass("slick-initialized")) {
        sliderpro.slick("unslick");
      }
      return;
    }
    if (!sliderpro.hasClass("slick-initialized")) {
      sliderpro.slick(settings);
      updatePagination(sliderpro);
      sliderpro.on("afterChange", function (event, slick, currentSlide) {
        updatePagination(sliderpro);
      });
    }
  });
}

function updatePagination(sliderpro) {
  var currentSlide = sliderpro.slick("slickCurrentSlide") + 1;
  var totalSlides = sliderpro.slick("getSlick").slideCount;
  $(".slick-pagination .current-slide").text(currentSlide);
  $(".slick-pagination .total-slides").text(totalSlides);
}

Slick_media($slick_sliderproduct, settings_sliderproduct);

// ==product variant sidebar
console.log($(".selector-wrapper.Size .radio__legend").length);
// console.log($(".selector-wrapper.Size .radio__legend"), "size ");
function drawerOpen() {
  $(".Vaiant_close").click(function () {
    $(".Variant_sidebar").removeClass("active");
    $(".theme__header").removeClass("z-index_auto");
    $(".product__content").removeClass("open_sidebar");
    $("body").css("overflow", "visible");
    $(".accordion").css("background-color", "fff");
    $(".Product_overlay").removeClass("active");
  });
  // console.log($(".selector-wrapper.Size .radio__button"), "size----");

  $(".selector-wrapper.Size .radio__button").click(function () {
    $(this).addClass("selected_size");
    let size_Radios = $(".selector-wrapper.Size .radio__legend").next();
    // console.log(size_Radios, "size_Radios----");
    let size_Radios_size = size_Radios.length;
    // console.log(size_Radios, "size_Radios----");

    const option1Selected = $(".radio__buttons.option-1")
      .children()
      .hasClass("selected_size");
    const option2Selected = $(".radio__buttons.option-2")
      .children()
      .hasClass("selected_size");
    // console.log(option1Selected, "option1Selected----");
    // console.log(option2Selected, "option2Selected----");

    if (size_Radios_size >= 2) {
      if (option1Selected && option2Selected) {
        $(".select--size-mob").text(window.theme.strings.addToCart);
        $(".select--size-mob").addClass("cart-trigger");
        // $('.product__submit button').removeClass('Select_a_size');
        $("small.radio__legend__value").css("display", "block");
        $(".add--cart").css("display", "flex");
        $(".select--size").css("display", "none");
        $(".product__price--strike").css("display", "block");
      }
    } else {
      $(".select--size-mob").text(window.theme.strings.addToCart);
      $(".select--size-mob").addClass("cart-trigger");
      // $('.product__submit button').removeClass('Select_a_size');
      $("small.radio__legend__value").css("display", "block");
      $(".add--cart").css("display", "flex");
      $(".select--size").css("display", "none");
      $(".product__price--strike").css("display", "block");
    }
  });

  $(".Product_overlay.active").click(function () {
    $(".Variant_sidebar").removeClass("active");
    $(".theme__header").removeClass("z-index_auto");
    $(".product__content").removeClass("open_sidebar");
    $("body").css("overflow", "visible");
    $(".accordion").css("background-color", "fff");
    $(".Product_overlay").removeClass("active");
  });
}
drawerOpen();
//setInterval(drawerOpen, 1000);
$(".add--cart").css("display", "none");

$(".cart-trigger").click(function () {
  $(".product__submit__item .btn").trigger("click");
});

$(".quick-add__button, .product__submit").click(function () {
  // console.log('interval');
  setInterval(drawerOpen, 1000);
});

function Productswip() {
  $(".product_collection_slider .Product-carousel-cell:first-child").hover(
    function () {
      $(".product_collection_slider .Product-carousel-cell:nth-child(2)")
        .parents(".product_collection_slider")
        .slick("slickGoTo", 0);
      $(this).parents(".product_collection_slider").slick("slickNext"); // Move to the next slide
    }
  );

  setTimeout(function () {
    $(".product_collection_slider .slick-slide:nth-child(2)").mouseleave(
      function () {
        $(this).parents(".product_collection_slider").slick("slickGoTo", 0); // Move to the next slide
        // $('.main-carousel').slick('slickPrev');
      }
    );
  }, 1000);
}
Productswip();

const ProductSwip = setInterval(Productswip, 1000);

var count = $(".product_collection_slider").children().length;

if (count >= 1) {
  function myStopFunction() {
    clearInterval(ProductSwip);
  }
}

$(document).ready(function () {
  $(".outer-section li:nth-child(1)").addClass(
    "service-messaging__slider__item"
  );
  $(".outer-section li:nth-child(2)").addClass(
    "service-messaging__slider__item--is-bold"
  );
  $(
    ".outer-section li:nth-child(6), .outer-section li:nth-child(10), .outer-section li:nth-child(14), .outer-section li:nth-child(18)"
  ).addClass(
    "service-messaging__slider__item--is-bold service-messaging__slider__item--first"
  );
   // Helper: get flickity instance (many ways themes attach it)
  function getFlickityInstance() {
    var sliderEl = document.querySelector('.product__slider');
    if (!sliderEl) return null;
    return sliderEl.flickity || sliderEl._flickity || $(sliderEl).data('flickity') || null;
  }

  // Get alt text of the currently selected slide (robust)
  function getSelectedSlideAlt() {
    var $sel = $('.product__slide.is-selected').first();
    if ($sel.length) {
      var alt = $sel.find('figure img').first().attr('alt');
      console.log("alt1233333",alt);
      if (alt && alt.trim() !== '') {
    return alt.trim();
      $sel.find('.model-size').show().removeClass('hidden-alt');
  } else if (!$sel.hasClass('hidden-alt')) {
    $sel.find('.model-size').hide().addClass('hidden-alt');
  }
    }

    var flkty = getFlickityInstance();
    if (flkty && (typeof flkty.selectedIndex === 'number' || typeof flkty.selected === 'number')) {
      var idx = (typeof flkty.selectedIndex === 'number') ? flkty.selectedIndex : flkty.selected;
      var $slide = $('.product__slide').eq(idx);
      if ($slide.length) {
        var alt2 = $slide.find('figure img').first().attr('alt');
        if (alt2 && alt2.trim() !== '') return alt2.trim();
      }
    }

    var $firstVisible = $('.product__slide').filter(function() {
      return $(this).is(':visible');
    }).first();
    if ($firstVisible.length) {
      var alt3 = $firstVisible.find('figure img').first().attr('alt');
      if (alt3 && alt3.trim() !== '') return alt3.trim();
    }

    return ''; 
  }

  // Update the displayed model-size text (global one)
  function updateAltText() {
    var alt = getSelectedSlideAlt();
    console.log("alt----",alt);
    if (alt) {
      $('.model-size-text').text(alt);
    } else {
      $('.model-size-text').text('');
    }
  }

  // 1️⃣ Open by default
  $(".model-size-wrapper").addClass("active");

  // Initial update on page load
  updateAltText();

  // 2️⃣ Toggle on click (open/close)
  $(".model-size-wrapper").on("click", function () {
    $(this).toggleClass("active");
    // updateAltText();

    var symbol = $(this).find(".toggle-symbol");
    if (symbol.length) {
      symbol.text($(this).hasClass("active") ? "-" : "+");
    }
  });

  // 3️⃣ Listen to Flickity events
  var $slider = $('.product__slider');
  if ($slider.length) {
    $slider.on('select.flickity change.flickity settle.flickity', function () {
      updateAltText();
    });

    var sliderEl = $slider.get(0);
    if (sliderEl) {
      var sliderObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            updateAltText();
          }
        });
      });
      sliderObserver.observe(sliderEl, { attributes: true, attributeOldValue: true });
    }
  }

  // 4️⃣ MutationObserver on slides
  var slideNodes = document.querySelectorAll('.product__slide');
  if (slideNodes && slideNodes.length) {
    var slideObserver = new MutationObserver(function (mutations) {
      var shouldUpdate = false;
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var oldVal = m.oldValue || '';
          var newVal = m.target.className || '';
          var had = oldVal.indexOf('is-selected') !== -1;
          var has = newVal.indexOf('is-selected') !== -1;
          if (had !== has) shouldUpdate = true;
        }
      });
      if (shouldUpdate) updateAltText();
    });

    slideNodes.forEach(function (node) {
      slideObserver.observe(node, { attributes: true, attributeOldValue: true });
    });
  }

  // 5️⃣ Precompute per slide: inject alt text into .model-size-text inside each slide
  // $('.product__slide').each(function() {
  //   var altText = $(this).find('figure img').first().attr('alt');
  //   if (altText && altText.trim() !== "") {
  //     $(this).find('.model-size-text').text(altText);
  //   }
  // });

  // 6️⃣ Update on load/resize/visibility change
  $(window).on('load resize visibilitychange', function() {
     $('.product__slide').each(function() {
    var altText = $(this).find('figure img').first().attr('alt');
    if (altText && altText.trim() !== "") {
      $(this).find('.model-size-text').text(altText);
    }
  });

    if (window.innerWidth <= 749) {
      //  $(".model-size-wrapper").addClass("active");
      updateAltText();
    }
  });
    var icon = $(".play , .marquee-content");
  icon.click(function () {
    icon.toggleClass("paused");
    return false;
  });
  $(".moreless-button").click(function () {
    $(".moretext").slideToggle();
    if ($(".moreless-button").text() == "Read more") {
      $(this).text("Read less");
    } else {
      $(this).text("Read more");
    }
  });
});

// ==drawer slider
function cartMatchproduct() {
  var $slick_slider_sidebar = $(".mini-cart__recommendations-list");
  var screen_size = 767;
  var settings_slider_sidebar = {
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  slick_on_mobile_side($slick_slider_sidebar, settings_slider_sidebar);

  function slick_on_mobile_side(slider, settings) {
    $(window).on("load resize", function () {
      if ($(window).width() > screen_size) {
        if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  }
  $(".drawer_shop_btn").click(function () {
    $(".drawer--cart .drawer__close").click();
  });
}

setInterval(cartMatchproduct, 1000);

$(document).ready(function () {
  jQuery.getJSON("/cart.js", function (cart) {
    var cartcount = cart.item_count;
    console.log("cartcount", cartcount);
    if (cartcount == 0) {
      $(".mini-cart__recommendations").addClass("is-hidden");
    } else {
      $(".mini-cart__recommendations").removeClass("is-hidden");
    }
  });

  $(".cart__item__remove").click(function () {
    jQuery.getJSON("/cart.js", function (cart) {
      var cartcount = cart.item_count;
      console.log("cartcount", cartcount);
      if (cartcount <= 1) {
        $(".mini-cart__recommendations").addClass("is-hidden");
      } else {
        $(".mini-cart__recommendations").removeClass("is-hidden");
      }
    });
  });
});

$(document).ready(function () {
  // Step 1: Only enable hover effect on DESKTOP (non-touch devices)
  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }
  
  // Step 2: Apply hover effect ONLY on desktop
  if (!isTouchDevice()) {
    // Desktop: Allow hover to show second image
    $(".collection_link").hover(
      function () {
        $(this)
          .parent(".grid-item")
          .find(".product-item__bg__under")
          .css("opacity", 1);
      },
      function () {
        $(this)
          .parent(".grid-item")
          .find(".product-item__bg__under")
          .css("opacity", ""); // Reset opacity on mouse leave
      }
    );
  } else {
    // Step 3: Mobile: Ensure second image stays hidden
    $(".product-item__bg__under").css("opacity", "0");
  }


  // $('.size-option').on('click', function () {
  //   $('.size-option').removeClass('active');
  //   $(this).addClass('active');

  //   // Enable the Add to Cart button
  //   $('.add-to-cart')
  //     .prop('disabled', false)
  //     .addClass('enabled');
  // });
});

$(document).ready(function () {
  // function toggleReadMore() {
  //   var content = $(".landingpage-text p span");
  //   var fullText = content.data("full-text") || content.html(); // Store full content
  //   var maxLength = fullText.indexOf("<br>"); // Cut off at first <br>
  //   var windowWidth = $(window).width();

  //   // Save full text if not already stored
  //   if (!content.data("full-text")) {
  //     content.data("full-text", fullText);
  //   }

  //   if (windowWidth <= 768) {
  //     // Mobile only
  //     if (maxLength !== -1) {
  //       var shortText = fullText.substring(0, maxLength);

  //       content.html(
  //         shortText + '... <a href="#" class="read-more">Read more</a>'
  //       );

  //       $(".landingpage-text")
  //         .off("click")
  //         .on("click", ".read-more", function (e) {
  //           e.preventDefault();
  //           content.html(
  //             fullText + ' <a href="#" class="read-less">Read less</a>'
  //           );
  //         });

  //       $(".landingpage-text").on("click", ".read-less", function (e) {
  //         e.preventDefault();
  //         content.html(
  //           shortText + '... <a href="#" class="read-more">Read more</a>'
  //         );
  //       });
  //     }
  //   } else {
  //     // Reset content when switching back to desktop
  //     content.html(fullText);
  //   }
  // }

  // toggleReadMore(); // Run on page load
  // $(window).resize(function () {
  //   setTimeout(toggleReadMore, 100); // Delay to avoid flickering
  // });

  function toggleReadMore() {
    var content = $(".landingpage-text p span");

    // Check if the element exists
    if (content.length === 0) {
      return; // Stop execution if element is not found
    }

    var fullText = content.data("full-text") || content.html().trim(); // Ensure content is valid
    var maxLength = fullText.indexOf("<br>"); // Find first <br> tag
    var windowWidth = $(window).width();

    // Save full text if not already stored
    if (!content.data("full-text")) {
      content.data("full-text", fullText);
    }

    if (windowWidth <= 768) {
      // Mobile only
      if (maxLength !== -1) {
        var shortText = fullText.substring(0, maxLength);

        content.html(
          shortText + '... <a href="#" class="read-more">Read more</a>'
        );

        $(".landingpage-text")
          .off("click")
          .on("click", ".read-more", function (e) {
            e.preventDefault();
            content.html(
              fullText + ' <a href="#" class="read-less">Read less</a>'
            );
          });

        $(".landingpage-text").on("click", ".read-less", function (e) {
          e.preventDefault();
          content.html(
            shortText + '... <a href="#" class="read-more">Read more</a>'
          );
        });
      }
    } else {
      // Reset content when switching back to desktop
      content.html(fullText);
    }
  }

  // Run only when the document is fully loaded
  $(document).ready(function () {
    toggleReadMore();
  });

  // Run on window resize (with delay to prevent flickering)
  $(window).resize(function () {
    setTimeout(toggleReadMore, 100);
  });

  $(".notify_me_click").on("click", function () {
    $(".bis-button").trigger("click");
  });

  /*--------------- mobile image slick slider ----------*/
$(".mobile-menu-image-slider").slick({
  slidesToShow: 2.1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: true,
  swipeToSlide: true
});
  $(".header__mobile__hamburger").on("click", function () {
    $(".mobile-menu-image-slider").slick("setPosition");
  });
  // $(".mobile-slider").slick({
  //   slidesToShow: 2,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   dots: false,
  //   speed: 300,
  //   infinite: true,
  //   autoplaySpeed: 5000,
  //   autoplay: false,
  // });
  /*--------------- mobile menu accordian ----------*/

// $(document).ready(function () {
//   // Open the first accordion section by default
//   $(".accordion_head").first().addClass("active");
//   $(".accordion_body").first().slideDown(0);
//   $(".accordion_head").first().find(".plusminus").attr(
//     "src",
//     "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_3.svg?v=1728983909"
//   );

//   $(".accordion_head").click(function () {
//     // If already open, do nothing
//     if ($(this).hasClass("active")) {
//       return;
//     }

//     // Remove active class and collapse all
//     $(".accordion_head").removeClass("active");
//     $(".accordion_body").slideUp(300);
//     $(".plusminus").attr(
//       "src",
//       "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_2.svg?v=1728983909"
//     );

//     // Open the clicked one
//     $(this).addClass("active");
//     $(this).next(".accordion_body").slideDown(300);
//     $(this).children(".plusminus").attr(
//       "src",
//       "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_3.svg?v=1728983909"
//     );
//   });
// });


  $(".accordion_head").click(function () {
    // Remove 'active' class from all accordion heads
    $(".accordion_head").removeClass("active");
    // Slide up all accordion bodies
    $(".accordion_body").slideUp(300);
    $(".plusminus").attr(
      "src",
      "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_2.svg?v=1728983909"
    );

    // Check if the clicked accordion body is already visible
    if ($(this).next(".accordion_body").is(":visible")) {
      $(this).next(".accordion_body").slideUp(300);
      $(this)
        .children(".plusminus")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_2.svg?v=1728983909"
        );
    } else {
      $(this).addClass("active"); // Add 'active' class to the clicked header
      $(this).next(".accordion_body").slideDown(300);
      $(this)
        .children(".plusminus")
        .attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0284/7355/7064/files/svgexport-14_3.svg?v=1728983909"
        );
    }
  });
  

  // Mobile image link click handler - only on desktop or non-touch
  $(".product-item__image a").on("click", function (event) {
    // Only handle on desktop (non-touch devices) 
    // On mobile, touchend handler will handle it
    if (!('ontouchstart' in window) && $(window).width() > 768) {
      const $parentImage = $(this).closest(".product-item__image");
      window.location.href = $(this).attr("href");
    }
  });

  // Step 4: Fix for iOS/Android - Prevent collection link from intercepting clicks on quick-add button  
  // CRITICAL: Only prevent collection_link navigation, don't interfere with quick-add button click
  $(document).on("click", ".collection_link", function (event) {
    var target = event.target;
    var $target = $(target);
    
    // Check if the click is on quick-add button or its children
    var clickedQuickAdd = $target.closest('.quick-add__button, .quick-add__holder, [data-quick-add-btn]').length > 0;
    
    // Check if clicking on product-link or product-item__info - let it handle navigation
    var clickedProductLink = $target.closest('.product-link, .product-item__info, .product-item__title').length > 0;
    
    // If clicking on product link/info, don't interfere - let product-link handle it
    if (clickedProductLink && !clickedQuickAdd) {
      return true; // Allow product-link to handle navigation
    }
    
    // If clicking on quick-add button, prevent collection link navigation only
    if (clickedQuickAdd) {
      event.preventDefault();  // Only prevent navigation
      event.stopPropagation(); // Stop propagation to prevent navigation
      // CRITICAL: Don't stop propagation - let the button's click event fire
      return false;
    }
  });
  
  // Step 5: iOS Safari support - Handle touch events properly
  if ('ontouchstart' in window) {
    // Prevent collection_link from interfering with plus button touchend
    $(document).on("touchend", ".collection_link", function (event) {
      var target = event.target;
      var $target = $(target);
      
      // Check if plus button was touched on this product item
      var $productItem = $target.closest('.product-item');
      if ($productItem.data('plus-button-touched')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
      
      // Check if touching product-link or product-item__info - let it handle navigation
      var touchedProductLink = $target.closest('.product-link, .product-item__info, .product-item__title').length > 0;
      
      // If touching product link/info, don't interfere - let product-link handle it
      if (touchedProductLink) {
        return true; // Allow product-link to handle navigation
      }
      
      // If touch ended on quick-add button, prevent collection link action
      if ($target.closest('.quick-add__button, .quick-add__holder, [data-quick-add-btn]').length) {
        event.preventDefault();
        event.stopPropagation(); // Stop propagation to prevent navigation
        event.stopImmediatePropagation(); // Stop all handlers
        // CRITICAL: Don't stop propagation - let the button handle the click
        return false;
      }
    });
    
    // Additional handler to prevent collection_link from interfering with plus button
    $(document).on("touchstart", ".collection_link", function (event) {
      var target = event.target;
      var $target = $(target);
      
      // Check if plus button was touched on this product item
      var $productItem = $target.closest('.product-item');
      if ($productItem.data('plus-button-touched')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }
      
      // If touching quick-add button, prevent collection link from handling
      if ($target.closest('.quick-add__button, .quick-add__holder, [data-quick-add-btn]').length) {
        event.preventDefault();
        event.stopPropagation(); // Stop propagation
        event.stopImmediatePropagation(); // Stop all handlers
        // Don't stop propagation - let touch events reach the button
      }
    });
    
    // SIMPLE FIX: Product link/info click on touch devices - redirect immediately without image change
    $(document).on("touchend", ".product-link, .product-item__info, .product-item__title", function (event) {
      if ($(window).width() <= 768) {
        var $link = $(this).closest('a.product-link');
        var $productItem = $(this).closest('.product-item');
        
        // Prevent image change
        $productItem.removeClass('touch-active');
        $productItem.removeAttr('data-touch-active');
        $productItem.find(".product-item__bg__under").css("opacity", "0");
        
        // If it's a link, navigate immediately
        if ($link.length && $link.attr('href')) {
          var href = $link.attr('href');
          event.preventDefault();
          event.stopPropagation();
          window.location.href = href;
          return false;
        }
      }
    });
    
    // Also handle click events
    $(document).on("click", ".product-link, .product-item__info, .product-item__title", function (event) {
      if ($(window).width() <= 768) {
        var $link = $(this).closest('a.product-link');
        var $productItem = $(this).closest('.product-item');
        
        // Prevent image change
        $productItem.removeClass('touch-active');
        $productItem.removeAttr('data-touch-active');
        $productItem.find(".product-item__bg__under").css("opacity", "0");
        
        // If it's a link, allow navigation
        if ($link.length && $link.attr('href')) {
          // Let the link navigate naturally
          return true;
        }
      }
    });
  }

  // Step 6: Mobile image hover effect - Handle touch events for image change
  // Requirements:
  // 1. Plus icon first touch: NO image change, dropdown open
  // 2. Close icon first touch: NO image change, dropdown close  
  // 3. Image area first touch: Image change + redirect
  if ('ontouchstart' in window) {
    
    // ============================================
    // SCROLL DETECTION - Prevent redirect if user was scrolling
    // ============================================
    
    var scrollDetected = false;
    var lastScrollTime = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var touchMoved = false;
    var touchStartElement = null;
    
    // Track scroll events - only mark as scrolling if actually scrolling
    window.addEventListener('scroll', function() {
      scrollDetected = true;
      lastScrollTime = Date.now();
    }, { passive: true });
    
    // Reset scroll detection after user stops scrolling
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        scrollDetected = false;
      }, 200); // Reset after 200ms of no scrolling
    }, { passive: true });
    
    // ============================================
    // PLUS ICON HANDLING - No image change, open dropdown
    // CRITICAL: These handlers MUST run FIRST (highest priority)
    // ============================================
    
    // Prevent image change when touching quick-add button - RUNS FIRST
    // Use native addEventListener for capture phase priority
    document.addEventListener("touchstart", function(event) {
      var target = event.target;
      var buttonElement = target.closest('.quick-add__button, [data-quick-add-btn]');
      
      if (!buttonElement) return;
      
      var $productItem = $(buttonElement).closest('.product-item');
      var $button = $(buttonElement);
      
      // CRITICAL: Clear any existing flags first to ensure fresh state
      $button.removeData('clicking');
      $button.removeData('touch-started');
      $button.removeData('is-plus-button');
      $productItem.removeData('plus-button-touched');
      $productItem.removeData('prevent-image-change');
      $productItem.removeData('prevent-redirect');
      
      // Remove touch-active immediately to prevent image change
      $productItem.removeClass('touch-active');
      $productItem.removeAttr('data-touch-active');
      
      // Mark that we're starting a touch - prevent image handlers
      $button.data('touch-started', true);
      $button.data('is-plus-button', true);
      
      // Mark product item to prevent image change and redirect
      $productItem.data('plus-button-touched', true);
      $productItem.attr('data-plus-button-touched', 'true');
      $productItem.data('prevent-image-change', true);
      $productItem.data('prevent-redirect', true);
      
      // DON'T preventDefault here - let touch events work normally
      // Only stop propagation to parent handlers (image handlers)
      event.stopPropagation();
    }, true); // Use capture phase for highest priority
    
    // Plus icon touchend - trigger dropdown open on first touch
    // Use native addEventListener for capture phase priority
    document.addEventListener("touchend", function(event) {
      var target = event.target;
      var buttonElement = target.closest('.quick-add__button, [data-quick-add-btn]');
      
      if (!buttonElement) return;
      
      var $productItem = $(buttonElement).closest('.product-item');
      var $button = $(buttonElement);
      
      // Check if already processing to prevent double triggers
      if ($button.data('processing-touch')) {
        return;
      }
      
      // Mark as processing
      $button.data('processing-touch', true);
      
      // CRITICAL: Don't prevent default - let click event fire naturally
      // Only stop propagation to prevent image handlers from interfering
      event.stopPropagation();
      
      // CRITICAL: Clear any stale flags first
      $button.removeData('clicking');
      
      // Ensure touch-active is removed (no image change)
      $productItem.removeClass('touch-active');
      $productItem.removeAttr('data-touch-active');
      
      // Mark product item to prevent any image/redirect handlers
      $productItem.data('plus-button-touched', true);
      $productItem.attr('data-plus-button-touched', 'true');
      $productItem.data('prevent-image-change', true);
      $productItem.data('prevent-redirect', true);
      
      // Mark button as clicked to prevent double triggers
      $button.data('clicking', true);
      
      // CRITICAL: Trigger click IMMEDIATELY using requestAnimationFrame
      // This ensures it happens before other handlers
      // On iOS, touchend naturally fires click, but we trigger it explicitly to ensure it works
      
      requestAnimationFrame(function() {
        try {
          if (buttonElement && !$button.data('click-triggered')) {
            $button.data('click-triggered', true);
            
            // Method 1: Direct click - most reliable for iPhone
            if (typeof buttonElement.click === 'function') {
              buttonElement.click();
            }
            
            // Method 2: Synthetic MouseEvent for better compatibility
            var syntheticClick = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
              detail: 1
            });
            buttonElement.dispatchEvent(syntheticClick);
            
            // Clear flag after short delay
            setTimeout(function() {
              $button.removeData('click-triggered');
            }, 100);
          }
        } catch(e) {
          console.log('Click trigger failed:', e);
          $button.removeData('click-triggered');
        }
      });
      
      // Also trigger via jQuery as backup (small delay to ensure it doesn't conflict)
      setTimeout(function() {
        try {
          if ($button.length && !$button.data('click-triggered')) {
            $button.data('click-triggered', true);
            $button.trigger('click');
            setTimeout(function() {
              $button.removeData('click-triggered');
            }, 100);
          }
        } catch(e) {
          console.log('jQuery trigger failed:', e);
          $button.removeData('click-triggered');
        }
      }, 10);
      
      // Check if modal opened - verify and retry if needed
      setTimeout(function() {
        try {
          var modalHandle = $button.attr('data-quick-add-modal-handle');
          if (modalHandle) {
            // Find modal by product handle or check all dialogs
            var modal = document.querySelector('dialog.product-quick-add[open]');
            
            if (!modal || !modal.hasAttribute('open')) {
              // Modal didn't open, try one more time with different methods
              if (buttonElement) {
                // Try direct click again
                if (typeof buttonElement.click === 'function') {
                  buttonElement.click();
                }
                
                // Try jQuery trigger
                $button.trigger('click');
                
                // Try finding and clicking the quick-add-product component
                var quickAddComponent = buttonElement.closest('quick-add-product');
                if (quickAddComponent && quickAddComponent.modalButton) {
                  quickAddComponent.modalButton.click();
                }
              }
            } else {
              // Modal opened successfully - cleanup flags immediately
              $button.removeData('clicking');
              $button.removeData('processing-touch');
              $button.removeData('touch-started');
              $button.removeData('is-plus-button');
              $productItem.removeData('plus-button-touched');
              $productItem.removeAttr('data-plus-button-touched');
              $productItem.removeData('prevent-image-change');
              $productItem.removeData('prevent-redirect');
            }
          }
        } catch(e) {
          console.log('Modal check failed:', e);
        }
      }, 100);
      
      // Cleanup processing flag after delay
      setTimeout(function() {
        $button.removeData('processing-touch');
        $button.removeData('clicking');
        $button.removeData('touch-started');
        $button.removeData('is-plus-button');
        $productItem.removeData('plus-button-touched');
        $productItem.removeAttr('data-plus-button-touched');
        $productItem.removeData('prevent-image-change');
        $productItem.removeData('prevent-redirect');
      }, 500);
    }, true); // Use capture phase for highest priority
    
    // Also ensure click event handler doesn't interfere - runs AFTER native handlers
    // This ensures the click works even if touchend didn't trigger properly
    $(document).on("click", ".quick-add__button, [data-quick-add-btn]", function (event) {
      var $productItem = $(this).closest('.product-item');
      var $button = $(this);
      
      // Ensure touch-active is removed
      $productItem.removeClass('touch-active');
      $productItem.removeAttr('data-touch-active');
      
      // Allow the click to proceed normally - don't prevent default
      // The quick-add-product component will handle the modal opening
    });
    
    // Additional handler to ensure click works on touch devices
    // This runs BEFORE the default handlers to ensure it works
    $(document).on("click", ".quick-add__button, [data-quick-add-btn]", function (event) {
      var $productItem = $(this).closest('.product-item');
      var $button = $(this);
      
      // Prevent image change when clicking plus button
      $productItem.removeClass('touch-active');
      $productItem.removeAttr('data-touch-active');
      $productItem.data('plus-button-touched', true);
      $productItem.attr('data-plus-button-touched', 'true');
      
      // Don't prevent default - let the click event work normally
    });
    
    // Listen for modal open event to confirm it's working
    document.addEventListener('theme:quick-add:open', function() {
      // Modal opened successfully, cleanup ALL flags immediately
      setTimeout(function() {
        $('.product-item').removeClass('touch-active');
        // Cleanup all flags from all buttons
        $('.quick-add__button, [data-quick-add-btn]').each(function() {
          var $button = $(this);
          var $productItem = $button.closest('.product-item');
          $button.removeData('clicking');
          $button.removeData('touch-started');
          $button.removeData('is-plus-button');
          $productItem.removeData('plus-button-touched');
          $productItem.removeData('prevent-image-change');
          $productItem.removeData('prevent-redirect');
        });
      }, 50);
    });
    
    // ============================================
    // CLOSE ICON HANDLING - No image change, close dropdown
    // ============================================
    
    // Prevent image change when touching close button
    $(document).on("touchstart", "[data-quick-add-modal-close], .product-quick-add__close", function (event) {
      // Stop propagation immediately to prevent any interference
      event.stopPropagation();
      // Remove touch-active from any product-items to prevent image change
      $('.product-item').removeClass('touch-active');
    });
    
    // Close icon touchend - trigger dropdown close on first touch
    $(document).on("touchend", "[data-quick-add-modal-close], .product-quick-add__close", function (event) {
      var closeButton = this;
      var $closeButton = $(closeButton);
      
      // Stop propagation to prevent product-item handlers from interfering
      event.stopPropagation();
      event.preventDefault();
      
      // Mark button as clicked to prevent double triggers
      if ($closeButton.data('clicking')) {
        return;
      }
      $closeButton.data('clicking', true);
      
      // Multiple methods to ensure modal closes reliably
      setTimeout(function() {
        try {
          if (closeButton && typeof closeButton.click === 'function') {
            closeButton.click();
          }
        } catch(e) {
          console.log('Close click failed:', e);
        }
        $closeButton.removeData('clicking');
      }, 0);
      
      // Fallback: Dispatch click event
      setTimeout(function() {
        try {
          if (closeButton && closeButton.dispatchEvent && !$closeButton.data('clicked')) {
            var clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });
            closeButton.dispatchEvent(clickEvent);
            $closeButton.data('clicked', true);
            setTimeout(function() {
              $closeButton.removeData('clicked');
            }, 500);
          }
        } catch(e) {
          console.log('Close dispatch failed:', e);
        }
      }, 10);
    });
    
    // ============================================
    // IMAGE AREA HANDLING - Image change on touch
    // ============================================
    
    // Handle touchstart on image area - trigger image change
    $(document).on("touchstart", ".product-item .product-item__image, .product-item .hover-second-image, .product-item .product-item__bg", function (event) {
      var target = event.target;
      var $target = $(target);
      var $productItem = $(this).closest('.product-item');
      
      // CRITICAL: Don't trigger image change if plus button was touched
      if ($productItem.data('plus-button-touched') || $productItem.data('prevent-image-change')) {
        event.preventDefault();
        event.stopPropagation();
        return; // Don't change image
      }
      
      // Don't trigger image change if touching quick-add button or close button
      if ($target.closest('.quick-add__button, .quick-add__holder, [data-quick-add-btn], [data-quick-add-modal-close], .product-quick-add__close').length) {
        event.preventDefault();
        event.stopPropagation();
        return; // Don't change image
      }
      
      // Track touch start position and time for scroll detection
      if (event.touches && event.touches.length > 0) {
        touchStartY = event.touches[0].clientY;
        touchStartTime = Date.now();
        touchMoved = false;
        touchStartElement = this;
      }
      
      // CRITICAL: Only prevent image change if user was ACTUALLY scrolling recently
      // Check if scroll happened within last 200ms before touch
      if (scrollDetected && (Date.now() - lastScrollTime < 200)) {
        $productItem.data('was-scrolling', true);
        return; // Don't change image if scrolling
      }
      
      // If not scrolling, allow normal behavior
      $productItem.removeData('was-scrolling');
      
      // Trigger image change on touchstart (only for image area)
      // Add touch-active class immediately for iPhone
      $productItem.addClass('touch-active');
      
      // Ensure image change happens even on iPhone Safari
      var $hoverSecondImage = $productItem.find('.hover-second-image');
      if ($hoverSecondImage.length && $hoverSecondImage.find('a').length > 1) {
        // Force image change by adding touch-active class
        $productItem.attr('data-touch-active', 'true');
      }
    });
    
    // Track touchmove to detect scrolling during touch
    $(document).on("touchmove", ".product-item .product-item__image, .product-item .hover-second-image", function (event) {
      var $productItem = $(this).closest('.product-item');
      
      // Only track if this is the same element where touch started
      if (touchStartElement !== this) {
        return;
      }
      
      touchMoved = true;
      
      // If touch moved significantly, mark as scrolling
      if (event.touches && event.touches.length > 0) {
        var touchMoveY = event.touches[0].clientY;
        var movement = Math.abs(touchMoveY - touchStartY);
        
        // If moved more than 15px vertically, consider it scrolling
        if (movement > 15) {
          $productItem.data('was-scrolling', true);
          $productItem.data('touch-moved', true);
          $productItem.removeClass('touch-active');
          $productItem.removeAttr('data-touch-active');
        }
      }
    });
    
    // Handle touchend on image link - trigger redirect on first touch
    $(document).on("touchend", ".product-item .product-item__image a, .product-item .hover-second-image a", function (event) {
      var target = event.target;
      var $target = $(target);
      var $link = $(this);
      var $productItem = $link.closest('.product-item');
      
      // CRITICAL: Don't trigger redirect if plus button was touched
      if ($productItem.data('plus-button-touched') || $productItem.data('prevent-redirect')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return; // Don't redirect
      }
      
      // Don't trigger redirect if touching quick-add button or close button
      if ($target.closest('.quick-add__button, .quick-add__holder, [data-quick-add-btn], [data-quick-add-modal-close], .product-quick-add__close').length) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return; // Let button handle click
      }
      
      // CRITICAL: Only prevent redirect if user was ACTUALLY scrolling
      // Check if scroll happened right before or during touch
      var wasScrolling = $productItem.data('was-scrolling') || 
                        $productItem.data('touch-moved') ||
                        (scrollDetected && (Date.now() - lastScrollTime < 200));
      
      // Also check if touch moved significantly (indicating scroll gesture)
      if (touchMoved && event.changedTouches && event.changedTouches.length > 0 && touchStartElement === this) {
        var touchEndY = event.changedTouches[0].clientY;
        var movement = Math.abs(touchEndY - touchStartY);
        
        // If moved more than 15px, consider it a scroll gesture - don't redirect
        if (movement > 15) {
          wasScrolling = true;
        }
      }
      
      // If scrolling detected, prevent redirect
      if (wasScrolling) {
        $productItem.removeData('was-scrolling');
        $productItem.removeData('touch-moved');
        $productItem.removeClass('touch-active');
        $productItem.removeAttr('data-touch-active');
        touchMoved = false;
        touchStartElement = null;
        event.preventDefault();
        event.stopPropagation();
        return; // Don't redirect if scrolling
      }
      
      // Check if this is on mobile
      if ($(window).width() <= 768) {
        var href = $link.attr('href');
        if (href) {
          // Prevent default to avoid double navigation
          event.preventDefault();
          event.stopPropagation();
          
          // Small delay to show image change, then redirect
          setTimeout(function() {
            // Final check before redirecting - ensure no scrolling happened
            var stillScrolling = scrollDetected && (Date.now() - lastScrollTime < 200);
            if (!$productItem.data('prevent-redirect') && 
                !$productItem.data('plus-button-touched') && 
                !$productItem.data('was-scrolling') &&
                !stillScrolling) {
              window.location.href = href;
            }
          }, 100); // Small delay to show image change
        }
      }
      
      // Reset flags for next touch
      $productItem.removeData('was-scrolling');
      $productItem.removeData('touch-moved');
      touchMoved = false;
      touchStartElement = null;
      
      // Cleanup data attributes after redirect delay
      setTimeout(function() {
        $productItem.removeClass('touch-active');
        $productItem.removeAttr('data-touch-active');
      }, 100);
    });
    
    // Remove touch-active when touch ends on product-item (except buttons)
    $(document).on("touchend", ".product-item", function (event) {
      var target = event.target;
      var $target = $(target);
      var $productItem = $(this);
      
      // CRITICAL: Don't handle if plus button was touched
      if ($productItem.data('plus-button-touched')) {
        return; // Let plus button handle everything
      }
      
      // Always remove touch-active if touching quick-add button or close button
      if ($target.closest('.quick-add__button, .quick-add__holder, [data-quick-add-btn], [data-quick-add-modal-close], .product-quick-add__close').length) {
        $productItem.removeClass('touch-active');
        $productItem.removeAttr('data-touch-active');
        return; // Let the button handle its own click
      }
      
      // Remove touch-active after a delay to allow image change to complete
      setTimeout(function() {
        if (!$productItem.data('plus-button-touched')) {
          $productItem.removeClass('touch-active');
          $productItem.removeAttr('data-touch-active');
        }
      }, 300);
    });
    
    // ============================================
    // CLEANUP HANDLERS
    // ============================================
    
    // Clean up when modal closes - this ensures state is reset
    $(document).on("click", "[data-quick-add-modal-close], .product-quick-add__close", function (event) {
      // Remove touch-active from all product-items when modal closes
      setTimeout(function() {
        $('.product-item').removeClass('touch-active');
        $('.product-item').removeAttr('data-touch-active');
        $('.product-item').removeAttr('data-plus-button-touched');
        $('.product-item').each(function() {
          $(this).removeData('plus-button-touched');
          $(this).removeData('prevent-image-change');
          $(this).removeData('prevent-redirect');
        });
      }, 100);
    });
    
    // Also listen for modal close via dialog backdrop click
    $(document).on("click", "dialog.product-quick-add", function (event) {
      if (event.target === this) {
        // Backdrop clicked, modal will close
        setTimeout(function() {
          $('.product-item').removeClass('touch-active');
          $('.product-item').removeAttr('data-touch-active');
          $('.product-item').removeAttr('data-plus-button-touched');
          $('.product-item').each(function() {
            $(this).removeData('plus-button-touched');
            $(this).removeData('prevent-image-change');
            $(this).removeData('prevent-redirect');
          });
        }, 100);
      }
    });
    
    // Handle backdrop touch events - ensure it closes on first touch
    $(document).on("touchend", "dialog.product-quick-add", function (event) {
      if (event.target === this) {
        // Backdrop touched, trigger click to close modal
        event.preventDefault();
        event.stopPropagation();
        setTimeout(function() {
          event.target.click();
        }, 0);
      }
    });
    
    // Watch for modal opening and cleanup touch-active when it opens
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          var modal = mutation.target;
          if (modal && modal.tagName === 'DIALOG' && modal.classList.contains('product-quick-add') && modal.hasAttribute('open')) {
            // Modal just opened, cleanup all touch-active classes
            setTimeout(function() {
              $('.product-item').removeClass('touch-active');
              $('.product-item').removeAttr('data-touch-active');
            }, 100);
          }
        }
        // Also check for newly added dialog elements
        if (mutation.addedNodes) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.tagName === 'DIALOG' && node.classList.contains('product-quick-add')) {
              observer.observe(node, { attributes: true, attributeFilter: ['open'] });
            }
          });
        }
      });
    });
    
    // Observe document body for dialog changes
    observer.observe(document.body, { 
      childList: true, 
      subtree: true, 
      attributes: true, 
      attributeFilter: ['open'] 
    });
    
    // Also observe existing dialogs
    document.querySelectorAll('dialog.product-quick-add').forEach(function(dialog) {
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    });
  }
});

// sort button in drawer
$(document).on("click", ".popout-list-option-drawer", function (event) {
  event.preventDefault();
  let dataVal = $(this).attr("data-value-option");
  console.log(dataVal, "dataVal---");
  let targetElement = $(`[data-value="${dataVal}"]`).get(0);
  console.log(targetElement, "trigger---");

  $(`[data-value="${dataVal}"]`).get(0).click();
});




$(document).on('click', '.product-quick-add__form .radio__button input[type="radio"]', function () {
  const $group = $(this).closest('.radio__buttons');

  // Remove active from all and add to clicked one
  $group.find('.radio__button').removeClass('active');
  $(this).closest('.radio__button').addClass('active');

  // Get the whole form
  const $form = $(this).closest('.product-quick-add__form');

  // Show the real Add to Cart button
  const $addToCartBtn = $form.find('#add--cart-btn-pro');
  const $selectSizeBtn = $form.find('.select--size');
  const $btnText = $addToCartBtn.find('.btn__text');

  $addToCartBtn.css('display', 'block');
  $selectSizeBtn.css('display', 'none');

  // Update the text based on disabled state
  setTimeout(function () {
    if ($addToCartBtn.prop('disabled')) {
      $btnText.text(window.theme.strings.soldOut);
    } else {
      $btnText.text(window.theme.strings.addToCart);
    }
  }, 100); // delay in case button disabled status updates after radio click
});


$(document).ready(function () {
  $('.form__wrapper').each(function () {
    const $wrapper = $(this);
    const $radioWrapper = $wrapper.find('.product__block .radio__buttons_2');
    const $addToCartBtn = $wrapper.find('#add--cart-btn-pro');
    const $selectSizeBtn = $wrapper.find('.select--size');
    const $btnText = $addToCartBtn.find('.btn__text');

    // Only if .radio__buttons_2 NOT found → show Add to cart
    if ($radioWrapper.length === 0) {
      $addToCartBtn.css('display', 'block');
      $selectSizeBtn.css('display', 'none');

      if ($addToCartBtn.prop('disabled')) {
        $btnText.text(window.theme.strings.soldOut);
      } else {
        $btnText.text(window.theme.strings.addToCart);
      }
    } else {
      // If size option exists, force select size
      $addToCartBtn.css('display', 'none');
      $selectSizeBtn.css('display', 'block');
    }
  });
});

$(document).on('click', '.form__wrapper .radio__button input[type="radio"]', function () {
  const $radio = $(this);
  const $formWrapper = $radio.closest('.form__wrapper');

  // 1. Set active style
  $formWrapper.find('.radio__button').removeClass('active');
  $radio.closest('.radio__button').addClass('active');

  // 2. Toggle buttons
  const $addToCartBtn = $formWrapper.find('#add--cart-btn-pro');
  const $selectSizeBtn = $formWrapper.find('.select--size');
  const $btnText = $addToCartBtn.find('.btn__text');

  $addToCartBtn.css('display', 'block');
  $selectSizeBtn.css('display', 'none');

  // 3. Text logic
  setTimeout(function () {
    if ($addToCartBtn.prop('disabled')) {
      $btnText.text(window.theme.strings.soldOut);
    } else {
      $btnText.text(window.theme.strings.addToCart);
    }
  }, 100);
});

setInterval(function () {
  if ($('.cart-bar').hasClass('is-visible')) {
    $('body').addClass('cart-bar-visible-padding');
  } else {
    $('body').removeClass('cart-bar-visible-padding');
  }
}, 300); // runs every 300ms

// ============================================
// GO BACK BUTTON HANDLING - Ensure it works on iPhone
// ============================================
$(document).ready(function() {
  function initGoBackHandlers() {
    var backButton = document.getElementById("backButton");
    if (!backButton) {
      setTimeout(initGoBackHandlers, 200);
      return;
    }
    
    var backButtonProcessing = false;
    
    function handleGoBack(event) {
      if (backButtonProcessing) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        return false;
      }
      
      backButtonProcessing = true;
      
      try {
        if (document.referrer) {
          window.location.href = document.referrer;
        } else {
          window.history.back();
        }
      } catch(e) {
        try {
          window.history.go(-1);
        } catch(e2) {
          console.log('Go back failed:', e2);
        }
      }
      
      setTimeout(function() {
        backButtonProcessing = false;
      }, 500);
      
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      return false;
    }
    
    // Simple touchend handler - no stopImmediatePropagation to allow zoom
    document.addEventListener("touchend", function(event) {
      var target = event.target;
      var backButtonElement = target.closest('#backButton');
      
      if (!backButtonElement) {
        var gobackLink = target.closest('.goback_link a');
        if (gobackLink && gobackLink.id === 'backButton') {
          backButtonElement = gobackLink;
        }
      }
      
      if (!backButtonElement) {
        var gobackContainer = target.closest('.goback_link');
        if (gobackContainer) {
          backButtonElement = gobackContainer.querySelector('#backButton');
        }
      }
      
      if (backButtonElement) {
        event.preventDefault();
        event.stopPropagation();
        // Don't use stopImmediatePropagation - allow zoom to work
        handleGoBack(event);
      }
    }, false); // Bubble phase instead of capture
    
    // Click handler
    $(document).off("click", "#backButton, .goback_link a#backButton, .goback_link");
    $(document).on("click", "#backButton, .goback_link a#backButton", function(event) {
      event.preventDefault();
      event.stopPropagation();
      handleGoBack(event);
    });
    
    $(document).on("click", ".goback_link", function(event) {
      if (event.target.id === 'backButton' || event.target.closest('#backButton')) {
        event.preventDefault();
        event.stopPropagation();
        handleGoBack(event);
      }
    });
  }
  
  initGoBackHandlers();
  setTimeout(initGoBackHandlers, 500);
  setTimeout(initGoBackHandlers, 1000);
    jQuery('.quick-add__holder').on('click', function() {

    // Remove show-img from ALL product items
    jQuery('.product-item').removeClass('show-img');

    // Add to the clicked product item only
    jQuery(this).closest('.product-item').addClass('show-img');

});
});

// add products directly in cart for Quick card 
document.addEventListener('click', function(e) {
  const option = e.target.closest('input[data-single-option-selector]');
  if (!option) return;

  const allowedContainer = option.closest(
    '.product-quick-add__form, upsell-product.mini-cart-recommendations'
  );
  if (!allowedContainer) return;

  const wrapper = option.closest('[data-form-wrapper]');
  if (!wrapper) return;

  const hiddenInput = wrapper.querySelector('input[name="id"]');
  if (!hiddenInput) return;
  setTimeout(() => {
    const addButton = wrapper.querySelector('[data-add-to-cart].add--cart');
    if (!addButton) return;

    if (wrapper.dataset.adding === 'true') return;
    wrapper.dataset.adding = 'true';

    addButton.click();

    setTimeout(() => {
      wrapper.dataset.adding = 'false';
    }, 500);
  }, 300);
});

window.addEventListener('DOMContentLoaded', function(){
  console.log('apply slider');
  applySlider();

  const observer = new MutationObserver(function (mutations, obs) {
    if (document.querySelector('.products-recommendation-section')) {
      applySlider();
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});